var map = {
	"./af.json": 846,
	"./am.json": 847,
	"./ar.json": 848,
	"./az.json": 849,
	"./be.json": 850,
	"./bg.json": 851,
	"./bn.json": 852,
	"./bs.json": 853,
	"./ca.json": 854,
	"./cs.json": 855,
	"./cy.json": 856,
	"./da.json": 857,
	"./de.json": 858,
	"./dv.json": 859,
	"./el.json": 860,
	"./en.json": 861,
	"./es.json": 862,
	"./et.json": 863,
	"./eu.json": 864,
	"./fa.json": 865,
	"./fi.json": 866,
	"./fr.json": 867,
	"./gl.json": 868,
	"./ha.json": 869,
	"./he.json": 870,
	"./hi.json": 871,
	"./hr.json": 872,
	"./hu.json": 873,
	"./hy.json": 874,
	"./id.json": 875,
	"./is.json": 876,
	"./it.json": 877,
	"./ja.json": 878,
	"./ka.json": 879,
	"./kk.json": 880,
	"./km.json": 881,
	"./ko.json": 882,
	"./ku.json": 883,
	"./ky.json": 884,
	"./lt.json": 885,
	"./lv.json": 886,
	"./mk.json": 887,
	"./ml.json": 888,
	"./mn.json": 889,
	"./ms.json": 890,
	"./nb.json": 891,
	"./nl.json": 892,
	"./nn.json": 893,
	"./no.json": 894,
	"./pl.json": 895,
	"./ps.json": 896,
	"./pt.json": 897,
	"./ro.json": 898,
	"./ru.json": 899,
	"./sd.json": 900,
	"./sk.json": 901,
	"./sl.json": 902,
	"./so.json": 903,
	"./sq.json": 904,
	"./sr.json": 905,
	"./sv.json": 906,
	"./sw.json": 907,
	"./ta.json": 908,
	"./tg.json": 909,
	"./th.json": 910,
	"./tr.json": 911,
	"./tt.json": 912,
	"./ug.json": 913,
	"./uk.json": 914,
	"./ur.json": 915,
	"./uz.json": 916,
	"./vi.json": 917,
	"./zh.json": 918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 845;